// 都更前台 RWD 斷點 mixin：手機 ≤833 / 平板 834–1200 / 桌機 ≥1201（對齊設計原型）
export default {
  data() {
    return {
      urWinWidth: (typeof window !== 'undefined' ? window.innerWidth : 1280),
    };
  },
  computed: {
    isMobile() {
      return this.urWinWidth <= 833;
    },
    isTablet() {
      return this.urWinWidth >= 834 && this.urWinWidth <= 1200;
    },
  },
  mounted() {
    this._urOnResize = () => { this.urWinWidth = window.innerWidth; };
    window.addEventListener('resize', this._urOnResize);
  },
  beforeDestroy() {
    if (this._urOnResize) window.removeEventListener('resize', this._urOnResize);
  },
};
